module.exports = __webpack_public_path__ + "static/media/17.f0be6343.svg";